import React from 'react'
import { usePopper } from 'react-popper'

export default function PopperElement (props) {
  const {
    referenceElementRef,
    children
  } = props

  const [popperElement, setPopperElement] = React.useState(null)
  const popper = usePopper(referenceElementRef, popperElement, {
    placement: 'bottom',
    offset: [100, 200]
  })

  return (
    <div ref={setPopperElement} style={popper.styles.popper} {...popper.attributes.popper}>
      {children}
    </div>
  )
}
